import React from "react";
import {Navigate, useParams} from 'react-router-dom';
// import axios from 'axios';
import Menu from "../components/menu/Menu";
import AddReco from "../components/add-reco/AddReco";
import {Container} from 'react-bootstrap';
import Verify from "../components/verify/Verify"
// import { trackPromise } from 'react-promise-tracker';

const AddRecoMain = () => {

    const params = useParams();
    var idcol = null;
    
    if(params){
        idcol = params.idcol
    }

    if(!sessionStorage.getItem('userData')){
        return <Navigate to="/"  />;
    }
    else{
        Verify()
    }
    
    return(
        <>
            <Menu />
            <Container>
                <h1 className="mt-4">Agregar reconocimiento facial - {idcol}</h1>
                <AddReco id={idcol} />
            </Container>
        </>
    )
};

export default AddRecoMain;
